export default __webpack_public_path__ + "static/media/gallery_02.f89262e2.jpg";